// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  padding: 20px;
  height: 100%;
  position: relative;
}

/* .contentItem:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 1px;
    background-color: #ddd;
} */


.day-item {
  padding: 10px;
  text-align: center;
  margin: 5px;
  border-radius: 5px;
  color: #1D1E25;
  font-weight: 600;
}

.day-item.today {
  color: #F15F50;
}

.day-item.weekend {
  color: #1D1E2566;
  text-decoration: line-through;
}

.weekly-orange-button {
  border: none;
  background-color: #F15F50;
  justify-content: space-between;
  padding-left: 22px;
  padding-right: 22px;
  padding-top: 18px;
  padding-bottom: 22px;
  width: 254px;
  height: 56px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-right: 24px;
  color: #FFFF;
}

.weekly-light-button {
  border: 1px solid #1D1E2533;
  background-color: #FFFF;
  justify-content: space-between;
  width: 264px;
  height: 56px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-right: 24px;
}

.weekly-active-plan-title {
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
}

.weekly-active-plan-values {
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;

}


.custom-tabs {
  background-color: #F1F5F7;
  border: none;
  border-radius: 8px;
  margin-bottom: 42px !important;
  margin-top: 32px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  justify-content: space-around;
}

.custom-tab {
  color: #1D1E2599;
  font-weight: bold;
  padding: 10px;
}

.custom-tab:hover {
  color: #F15F50;
  border: none;
}

.custom-tab.active {
  color: #1D1E25;
  border: none;
}


.custom-checkbox-label {
  border: 2px dashed #1D1E2533;
  border-radius: 12px;
  padding: 10px;
  margin: 5px;
  text-align: center;
  height: 52px;
  padding-right: 18px !important;
}

.custom-checkbox {
  padding: 5px;
}


.discount-button {
  border: 2px dashed #1D1E2533 !important;
  width: 150px;
  height: 82px;
  background-color: transparent;
  border-radius: 12px;
  padding: 10px;
  color: #1D1E2533;
  margin-right: 24px;
  font-weight: 600;
  font-size: 40px;
  margin-bottom: 24px;
}


.selected-discount-button {
  border: 2px dashed #1D1E25 !important;
  width: 170px;
  height: 82px;
  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);
  color: #fff !important;
  margin-right: 24px;
  font-weight: 600;
  font-size: 40px;
  border-radius: 12px;
  margin-bottom: 24px;
}


.active-checkbox {
  border: 2px dashed #1D1E25;
  border-radius: 12px;
  padding: 10px;
  margin: 5px;
  text-align: center;
  height: 52px;
  padding-right: 18px !important;
}

.day-item {
  padding: 10px;
  border-radius: 5px;
  margin-right: 5px;
}

.today {
  color: #F15F50;
  /* Turuncu renk */
  font-weight: bold;
}

.inactive {
  opacity: 0.5;
  text-decoration: line-through;
}

.weekly-plan-content button {
  border-radius: 12px;
  background-color: #fff;
  padding: 16px 32px;
  font-weight: 600;
  font-size: 25px;
}

#cancel-button {
  padding: 10px;
  border: 1px solid #1D1E2533;
  width: 132px;
  height: 56px;
  font-size: 16px !important;
  line-height: 30px;
  background-color: transparent;
  border-radius: 8px;
}

.future-plan-info p {
  font-size: 22px !important;
  line-height: 26px !important;
}

.future-plan-info-button {
  margin-bottom: 15px !important;
  margin-left: 0px !important;
  text-align: left;
  font-size: 24px;
  font-weight: 600;
}

.discountButtons button {
  width: 140px !important;
  height: 82px;
  border: 2px dashed #1D1E2533;
  margin-bottom: 20px;
  margin-right: 10px;
  font-size: 40px;
  padding: unset;
  color: #1D1E2533;
}

.discountButtons .selected-button {
  width: 160px !important;
}

input::placeholder {
  color: #666;
  opacity: 1;
  /* Görünürlüğü artır */
  font-size: 14px;
  /* Uygun boyutta olduğundan emin olun */
}
.nav-fill .nav-item .nav-link, .nav-justified .nav-item .nav-link{
  width: 82% ;
  border-radius: 8px;
}
.navbar-right-part{
  display: contents;
}
@media (max-width: 768px) {
  .navbar {
    align-items: center;
  }

  .backgroundDiv {
    display: none;
  }

  .overlay-div {
    margin-top: 16px !important;
    width: calc(100vw - 30px);
    height: unset !important;
    left: 6px;
    margin-left: 10px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

  }

  .contentDiv {
    margin-left: 0px;
  }

  .upperContent-p {
    font-size: 14px !important;
    margin-right: 16px;
  }

  .upperContent button {
    font-size: 14px !important;
    width: 130px !important;
    padding: 10px;
  }

  #select-daily-time-p {
    padding-right: 16px !important;
  }

  #select-daily-campaign-start-time {
    color: #1D1E25 !important;
    font-size: 18px !important;
    width: calc(100% - 16px) !important;
    height: 56px !important;
    padding: 16px !important;
    margin-right: 16px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #select-daily-campaign-end-time {
    color: #1D1E25 !important;
    width: calc(100% - 16px) !important;
    font-size: 18px !important;
    height: 56px !important;
    padding: 16px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .saleButtons button {
    width: 70px !important;
    height: 55px;
    margin-bottom: 16px;
  }

  .saleButtons .selected-button {
    width: 96px !important;
  }

  .extend-session-button {
    padding: 0px !important;
    width: 20px !important;
    margin-bottom: 0px !important;
  }

  .bottomLinks {
    font-size: 12px;
  }

  .contract p {
    font-size: 14px;
    margin-left: 10px;
    margin-right: 24px;
    margin-top: 16px;
    margin-bottom: 16px !important;
  }

  .custom-checkbox-label {
    padding: 0px;
    height: 45px;
    width: 105%;
    margin-right: 0px !important;
}

  .weekly-planning-time-selection {
    display: block !important;
    margin-bottom: 24px !important;
  }

  .weekly-planning-first-time-selection {
    margin-bottom: 24px;
  }

  .line {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }

  .line-mobile-display {
    display: none;
  }
.special-discount-button{
  width: 296px !important;
}
  .weekly-planning-discount-buttons {
    margin-bottom: 24px;
    text-align: center;
    /* margin-left: 16px; */
  }

  .active-weekly-plan-info {
    display: block !important;
  }

  .weekly-planning-subtitle {
    font-size: 20px !important;
    font-weight: 200;
  }

  #close-button {
    width: 134px !important;
    height: 56px;
    color: #1D1E25 !important;
  }

  .discount-button {
    padding: 10px;
    width: 140px;
    height: 82px;
    font-size: 40px;
    margin-right: 16px;
    margin-bottom: 16px;
}

  .selected-discount-button {
    font-size: 40px;
    width: 296px;
    height: 82px;
    margin-right: 16px !important;
  }

  .stopSession button {
    font-size: 14px !important;
    padding: unset;
    color: #1D1E25 !important;
  }

  .weekly-middle-div {
    display: none;
  }

  .missing-day-first-time-input {
    margin-bottom: 24px;
  }

  .css-1dwzut6-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {
    margin-right: 10px !important;
  }

  .weekly-active-plan-title {
    font-size: 12px;
  }

  .weekly-active-plan-values {
    font-size: 40px !important;
    font-weight: 600 !important;
  }

  .contentItem {
    width: 100%;
  }

  .weekly-active-plan-title {
    font-size: 20px !important;
    line-height: 30px;
  }

  .week-days-container {
    display: ruby !important;
  }

  .day-item {
    font-size: 14px;
  }

  .weekly-plan-buttons {
    text-align: center;
  }

  .weekly-orange-button {
    width: 100%;
    margin-bottom: 15px;
    font-size: 14px;
    margin-right: unset;

  }

  .weekly-light-button {
    width: 100%;
    margin-bottom: 15px;
    font-size: 14px;
    margin-right: unset;
    color: #1D1E25 !important;

  }

  .edit-campaign-times-container {
    display: block !important;
  }

  .popup-content {
    max-height: 700px;
    overflow: auto !important;
  }

  #edit-campaing-time-disabled {
    width: 200px !important;
    padding: unset !important;
    height: 82px;
    font-size: 40px !important;
    margin-bottom: 20px !important;
  }

  .icon {
    width: 25px !important;
    margin-bottom: 5px !important;
  }

  .css-13kidl1-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {
    height: 60px !important;
    width: 190px !important;
  }

  .edit-campaign-line {
    margin-top: 0px !important;
  }

  .date-title {
    margin-top: 20px !important;
  }

  .stopSession {
    align-items: center;
  }

  .css-1dwzut6-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {
    height: 60px !important;
  }

  .active-campaign-info-container {
    display: block !important;
  }

  .active-campaign-info-container p {
    font-size: 16px;
    font-weight: 200;
  }

  .active-campaign-info {
    width: 100% !important;
  }

  #timerMobileButton {
    border: none !important;
    font-size: 24px !important;
    width: 100% !important;
    text-align: left;
    color: #1D1E25 !important;
  }

  .extend-session-container {
    padding-left: 35px !important;
    padding-right: 16px !important;

  }

  .weekly-planning-days {
    display: grid !important;
    padding-right: 0px !important;
  }

  .discountButtons button {
    width: 140px !important;
    height: 82px;
    border: 2px dashed #1D1E2533;
    margin-bottom: 20px;
    margin-right: 10px;
    font-size: 40px;
    padding: unset;
    color: #1D1E2533;
  }

  .discountButtons .selected-button {
    width: 160px !important;
  }

  .future-plan-info {
    display: block !important;
  }

  .future-plan-info p {
    font-size: 22px !important;
    line-height: 26px !important;
  }

  .future-plan-info-button {
    margin-bottom: 15px !important;
    margin-left: 0px !important;
    text-align: left;
    font-size: 24px;
    font-weight: 600;
  }

  #cancel-button {
    padding: 10px;
    border: 1px solid #1D1E2533;
    width: 132px;
    height: 56px;
    font-size: 16px !important;
    line-height: 30px;
    background-color: transparent;
    border-radius: 8px;
  }

  .custom-tabs {
    margin-bottom: 24px !important;
    display: flex;
    align-items: center;
  }

  .navbar-right-part {
    display: flex;
    top: 0px;
    align-items: center;
  }
  .nav-justified .nav-item,
.nav-justified>.nav-link {
  flex-grow: 0 !important;
}

}`, "",{"version":3,"sources":["webpack://./src/components/styles/ActiveWeeklyStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;GAQG;;;AAGH;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;;AAGA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,4DAA4D;EAC5D,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,SAAS;IACT,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;;EAE/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,mCAAmC;IACnC,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mCAAmC;IACnC,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;EAEE;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;EACE,uBAAuB;AACzB;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;EAEE;IACE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,mBAAmB;;EAErB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;;EAE3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;;EAEhC;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;EACA;;EAEA,uBAAuB;AACzB;;AAEA","sourcesContent":[".contentItem {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  text-align: left;\n  padding: 20px;\n  height: 100%;\n  position: relative;\n}\n\n/* .contentItem:not(:last-child)::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 1px;\n    background-color: #ddd;\n} */\n\n\n.day-item {\n  padding: 10px;\n  text-align: center;\n  margin: 5px;\n  border-radius: 5px;\n  color: #1D1E25;\n  font-weight: 600;\n}\n\n.day-item.today {\n  color: #F15F50;\n}\n\n.day-item.weekend {\n  color: #1D1E2566;\n  text-decoration: line-through;\n}\n\n.weekly-orange-button {\n  border: none;\n  background-color: #F15F50;\n  justify-content: space-between;\n  padding-left: 22px;\n  padding-right: 22px;\n  padding-top: 18px;\n  padding-bottom: 22px;\n  width: 254px;\n  height: 56px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  margin-right: 24px;\n  color: #FFFF;\n}\n\n.weekly-light-button {\n  border: 1px solid #1D1E2533;\n  background-color: #FFFF;\n  justify-content: space-between;\n  width: 264px;\n  height: 56px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  margin-right: 24px;\n}\n\n.weekly-active-plan-title {\n  font-weight: 200;\n  font-size: 20px;\n  line-height: 30px;\n}\n\n.weekly-active-plan-values {\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 50px;\n\n}\n\n\n.custom-tabs {\n  background-color: #F1F5F7;\n  border: none;\n  border-radius: 8px;\n  margin-bottom: 42px !important;\n  margin-top: 32px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.custom-tab {\n  color: #1D1E2599;\n  font-weight: bold;\n  padding: 10px;\n}\n\n.custom-tab:hover {\n  color: #F15F50;\n  border: none;\n}\n\n.custom-tab.active {\n  color: #1D1E25;\n  border: none;\n}\n\n\n.custom-checkbox-label {\n  border: 2px dashed #1D1E2533;\n  border-radius: 12px;\n  padding: 10px;\n  margin: 5px;\n  text-align: center;\n  height: 52px;\n  padding-right: 18px !important;\n}\n\n.custom-checkbox {\n  padding: 5px;\n}\n\n\n.discount-button {\n  border: 2px dashed #1D1E2533 !important;\n  width: 150px;\n  height: 82px;\n  background-color: transparent;\n  border-radius: 12px;\n  padding: 10px;\n  color: #1D1E2533;\n  margin-right: 24px;\n  font-weight: 600;\n  font-size: 40px;\n  margin-bottom: 24px;\n}\n\n\n.selected-discount-button {\n  border: 2px dashed #1D1E25 !important;\n  width: 170px;\n  height: 82px;\n  background: linear-gradient(90deg, #F15F50 0%, #F9B061 100%);\n  color: #fff !important;\n  margin-right: 24px;\n  font-weight: 600;\n  font-size: 40px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n\n.active-checkbox {\n  border: 2px dashed #1D1E25;\n  border-radius: 12px;\n  padding: 10px;\n  margin: 5px;\n  text-align: center;\n  height: 52px;\n  padding-right: 18px !important;\n}\n\n.day-item {\n  padding: 10px;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.today {\n  color: #F15F50;\n  /* Turuncu renk */\n  font-weight: bold;\n}\n\n.inactive {\n  opacity: 0.5;\n  text-decoration: line-through;\n}\n\n.weekly-plan-content button {\n  border-radius: 12px;\n  background-color: #fff;\n  padding: 16px 32px;\n  font-weight: 600;\n  font-size: 25px;\n}\n\n#cancel-button {\n  padding: 10px;\n  border: 1px solid #1D1E2533;\n  width: 132px;\n  height: 56px;\n  font-size: 16px !important;\n  line-height: 30px;\n  background-color: transparent;\n  border-radius: 8px;\n}\n\n.future-plan-info p {\n  font-size: 22px !important;\n  line-height: 26px !important;\n}\n\n.future-plan-info-button {\n  margin-bottom: 15px !important;\n  margin-left: 0px !important;\n  text-align: left;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.discountButtons button {\n  width: 140px !important;\n  height: 82px;\n  border: 2px dashed #1D1E2533;\n  margin-bottom: 20px;\n  margin-right: 10px;\n  font-size: 40px;\n  padding: unset;\n  color: #1D1E2533;\n}\n\n.discountButtons .selected-button {\n  width: 160px !important;\n}\n\ninput::placeholder {\n  color: #666;\n  opacity: 1;\n  /* Görünürlüğü artır */\n  font-size: 14px;\n  /* Uygun boyutta olduğundan emin olun */\n}\n.nav-fill .nav-item .nav-link, .nav-justified .nav-item .nav-link{\n  width: 82% ;\n  border-radius: 8px;\n}\n.navbar-right-part{\n  display: contents;\n}\n@media (max-width: 768px) {\n  .navbar {\n    align-items: center;\n  }\n\n  .backgroundDiv {\n    display: none;\n  }\n\n  .overlay-div {\n    margin-top: 16px !important;\n    width: calc(100vw - 30px);\n    height: unset !important;\n    left: 6px;\n    margin-left: 10px;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n\n  }\n\n  .contentDiv {\n    margin-left: 0px;\n  }\n\n  .upperContent-p {\n    font-size: 14px !important;\n    margin-right: 16px;\n  }\n\n  .upperContent button {\n    font-size: 14px !important;\n    width: 130px !important;\n    padding: 10px;\n  }\n\n  #select-daily-time-p {\n    padding-right: 16px !important;\n  }\n\n  #select-daily-campaign-start-time {\n    color: #1D1E25 !important;\n    font-size: 18px !important;\n    width: calc(100% - 16px) !important;\n    height: 56px !important;\n    padding: 16px !important;\n    margin-right: 16px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  #select-daily-campaign-end-time {\n    color: #1D1E25 !important;\n    width: calc(100% - 16px) !important;\n    font-size: 18px !important;\n    height: 56px !important;\n    padding: 16px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .saleButtons button {\n    width: 70px !important;\n    height: 55px;\n    margin-bottom: 16px;\n  }\n\n  .saleButtons .selected-button {\n    width: 96px !important;\n  }\n\n  .extend-session-button {\n    padding: 0px !important;\n    width: 20px !important;\n    margin-bottom: 0px !important;\n  }\n\n  .bottomLinks {\n    font-size: 12px;\n  }\n\n  .contract p {\n    font-size: 14px;\n    margin-left: 10px;\n    margin-right: 24px;\n    margin-top: 16px;\n    margin-bottom: 16px !important;\n  }\n\n  .custom-checkbox-label {\n    padding: 0px;\n    height: 45px;\n    width: 105%;\n    margin-right: 0px !important;\n}\n\n  .weekly-planning-time-selection {\n    display: block !important;\n    margin-bottom: 24px !important;\n  }\n\n  .weekly-planning-first-time-selection {\n    margin-bottom: 24px;\n  }\n\n  .line {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n\n  .line-mobile-display {\n    display: none;\n  }\n.special-discount-button{\n  width: 296px !important;\n}\n  .weekly-planning-discount-buttons {\n    margin-bottom: 24px;\n    text-align: center;\n    /* margin-left: 16px; */\n  }\n\n  .active-weekly-plan-info {\n    display: block !important;\n  }\n\n  .weekly-planning-subtitle {\n    font-size: 20px !important;\n    font-weight: 200;\n  }\n\n  #close-button {\n    width: 134px !important;\n    height: 56px;\n    color: #1D1E25 !important;\n  }\n\n  .discount-button {\n    padding: 10px;\n    width: 140px;\n    height: 82px;\n    font-size: 40px;\n    margin-right: 16px;\n    margin-bottom: 16px;\n}\n\n  .selected-discount-button {\n    font-size: 40px;\n    width: 296px;\n    height: 82px;\n    margin-right: 16px !important;\n  }\n\n  .stopSession button {\n    font-size: 14px !important;\n    padding: unset;\n    color: #1D1E25 !important;\n  }\n\n  .weekly-middle-div {\n    display: none;\n  }\n\n  .missing-day-first-time-input {\n    margin-bottom: 24px;\n  }\n\n  .css-1dwzut6-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {\n    margin-right: 10px !important;\n  }\n\n  .weekly-active-plan-title {\n    font-size: 12px;\n  }\n\n  .weekly-active-plan-values {\n    font-size: 40px !important;\n    font-weight: 600 !important;\n  }\n\n  .contentItem {\n    width: 100%;\n  }\n\n  .weekly-active-plan-title {\n    font-size: 20px !important;\n    line-height: 30px;\n  }\n\n  .week-days-container {\n    display: ruby !important;\n  }\n\n  .day-item {\n    font-size: 14px;\n  }\n\n  .weekly-plan-buttons {\n    text-align: center;\n  }\n\n  .weekly-orange-button {\n    width: 100%;\n    margin-bottom: 15px;\n    font-size: 14px;\n    margin-right: unset;\n\n  }\n\n  .weekly-light-button {\n    width: 100%;\n    margin-bottom: 15px;\n    font-size: 14px;\n    margin-right: unset;\n    color: #1D1E25 !important;\n\n  }\n\n  .edit-campaign-times-container {\n    display: block !important;\n  }\n\n  .popup-content {\n    max-height: 700px;\n    overflow: auto !important;\n  }\n\n  #edit-campaing-time-disabled {\n    width: 200px !important;\n    padding: unset !important;\n    height: 82px;\n    font-size: 40px !important;\n    margin-bottom: 20px !important;\n  }\n\n  .icon {\n    width: 25px !important;\n    margin-bottom: 5px !important;\n  }\n\n  .css-13kidl1-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {\n    height: 60px !important;\n    width: 190px !important;\n  }\n\n  .edit-campaign-line {\n    margin-top: 0px !important;\n  }\n\n  .date-title {\n    margin-top: 20px !important;\n  }\n\n  .stopSession {\n    align-items: center;\n  }\n\n  .css-1dwzut6-MuiFormControl-root-MuiTextField-root .MuiInputBase-root {\n    height: 60px !important;\n  }\n\n  .active-campaign-info-container {\n    display: block !important;\n  }\n\n  .active-campaign-info-container p {\n    font-size: 16px;\n    font-weight: 200;\n  }\n\n  .active-campaign-info {\n    width: 100% !important;\n  }\n\n  #timerMobileButton {\n    border: none !important;\n    font-size: 24px !important;\n    width: 100% !important;\n    text-align: left;\n    color: #1D1E25 !important;\n  }\n\n  .extend-session-container {\n    padding-left: 35px !important;\n    padding-right: 16px !important;\n\n  }\n\n  .weekly-planning-days {\n    display: grid !important;\n    padding-right: 0px !important;\n  }\n\n  .discountButtons button {\n    width: 140px !important;\n    height: 82px;\n    border: 2px dashed #1D1E2533;\n    margin-bottom: 20px;\n    margin-right: 10px;\n    font-size: 40px;\n    padding: unset;\n    color: #1D1E2533;\n  }\n\n  .discountButtons .selected-button {\n    width: 160px !important;\n  }\n\n  .future-plan-info {\n    display: block !important;\n  }\n\n  .future-plan-info p {\n    font-size: 22px !important;\n    line-height: 26px !important;\n  }\n\n  .future-plan-info-button {\n    margin-bottom: 15px !important;\n    margin-left: 0px !important;\n    text-align: left;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  #cancel-button {\n    padding: 10px;\n    border: 1px solid #1D1E2533;\n    width: 132px;\n    height: 56px;\n    font-size: 16px !important;\n    line-height: 30px;\n    background-color: transparent;\n    border-radius: 8px;\n  }\n\n  .custom-tabs {\n    margin-bottom: 24px !important;\n    display: flex;\n    align-items: center;\n  }\n\n  .navbar-right-part {\n    display: flex;\n    top: 0px;\n    align-items: center;\n  }\n  .nav-justified .nav-item,\n.nav-justified>.nav-link {\n  flex-grow: 0 !important;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
